export const Information = (props) => {
  const { size = 16, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7.99967 10.7933V8.12663M7.99967 5.45996H8.00634M14.6663 8.12663C14.6663 11.8085 11.6816 14.7933 7.99967 14.7933C4.31778 14.7933 1.33301 11.8085 1.33301 8.12663C1.33301 4.44473 4.31778 1.45996 7.99967 1.45996C11.6816 1.45996 14.6663 4.44473 14.6663 8.12663Z'
          stroke='currentcolor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};
